import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { GoogleOAuthProvider } from "@react-oauth/google";

import { AuthProvider, useAuth } from "./context/AuthContext";
import Landing from "./pages/Landing";
import Dashboard from "./pages/Dashboard";
import Payment from "./pages/Payment";
import AuthCallback from "./pages/AuthCallback";
import AdminPortal from "./pages/AdminPortal";
import Terms from "./pages/Terms";
import ScrollToTop from "./components/sinpe/ScrollToTop";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-white" data-testid="auth-loading">
                <div className="h-10 w-10 rounded-full border-2 border-[#064E3B] border-t-transparent animate-spin" />
            </div>
        );
    }
    if (!user) return <Navigate to="/" replace />;
    return children;
};

function AppRouter() {
    const location = useLocation();
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <>
            <ScrollToTop />
            <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/terminos" element={<Terms />} />
            <Route path="/pay/:sellerId" element={<Payment />} />
            <Route
                path="/dashboard"
                element={
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/admin-portal"
                element={
                    <ProtectedRoute>
                        <AdminPortal />
                    </ProtectedRoute>
                }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </>
    );
}

function App() {
    return (
        <div className="App">
            <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
                <BrowserRouter>
                    <AuthProvider>
                        <AppRouter />
                        <Toaster position="top-right" richColors closeButton />
                    </AuthProvider>
                </BrowserRouter>
            </GoogleOAuthProvider>
        </div>
    );
}

export default App;
